import { render, staticRenderFns } from "./Topics.vue?vue&type=template&id=64cb2b9e&scoped=true&"
import script from "./Topics.vue?vue&type=script&lang=js&"
export * from "./Topics.vue?vue&type=script&lang=js&"
import style0 from "./Topics.vue?vue&type=style&index=0&id=64cb2b9e&prod&lang=css&"
import style1 from "./Topics.vue?vue&type=style&index=1&id=64cb2b9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cb2b9e",
  null
  
)

export default component.exports